module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/placeholder-864d20392d2bb7290798a8e18de7dbf7.png";